<app-header></app-header>
<app-navbar [selected]="'taxes'"></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [subItems]="subLinks" [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <div [formGroup]="filterParams">
            <div class="row">
                <div class="col-4 modelinput">
                    <label for="taxType">{{ 'model.taxType' | translate }} *</label>
                    <select class="form-select" aria-label="taxType" id="taxType" name="taxType"
                        formControlName="taxType">
                        <option [value]=""></option>
                        <option [value]="'O'">{{ 'model.official' | translate }}</option>
                        <option [value]="'P'">{{ 'model.own' | translate }}</option>
                    </select>
                </div>
            </div>
            <div class="row align-items-center">
                <!--                <div class="modelinput col-md-3">
                    <label>{{ 'model.name' | translate }}</label>
                    <input type="text" class="form-control" placeholder="Name" formControlName="name"
                        (input)="onFilterChange()" />
                </div>-->

                <div class="modelinput col-md-4">
                    <label for="codeModel">{{ 'model.code' | translate }}</label>
                    <input type="text" class="form-control" name="codeModel" id="codeModel" placeholder="Código"
                        formControlName="codeModel" (input)="onFilterChange()" />
                </div>
                <div class="modelinput col-md-4">
                    <label for="status">{{ 'model.status' | translate }}</label>
                    <select class="form-select" id="status" name="status" formControlName="status"
                        (change)="onFilterChange()">
                        <option [value]="''"></option>
                        <option [value]="'S'">{{ 'model.active' | translate }}</option>
                        <option [value]="'N'">{{ 'model.inactive' | translate }}</option>
                    </select>
                </div>
                <div class="text-end col mt-2">
                    <button type="button" class="btn custombutton" id="clone" (click)="clone()"
                        [disabled]="selectedRowId == null || selectAll">{{'Clonar' | translate }}</button>
                    <button type="button" class="btn custombutton ms-2" id="export" (click)="export()"
                        [disabled]="selectedRowId == null || selectAll">{{'Exportar' | translate }}</button>
                    <button type="button" class="btn custombutton ms-2" (click)="onNewModelClick()">{{'model.newModel' |
                        translate}}</button>
                </div>
            </div>
        </div>
        <div>
            @if (this.filterParams.get('taxType')?.value) {
            <fieldset>
                <table class="table ">
                    <thead>
                        <tr>
                            <th scope="col" aria-label="check"><input (change)="selectAllFiles()" type="checkbox"
                                    name="checkbox2" aria-label="checkbox" />
                                <span class="visually-hidden">{{'seleccionar' | translate}}</span>
                            </th>
                            <th scope="col">{{'model.code' | translate}}</th>
                            <th scope="col" style="width: 30%">{{'model.name' | translate}}</th>
                            <th scope="col">{{'model.serviceType' | translate}}</th>
                            <th scope="col">{{'model.status' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of this.modelResponse.listRateModelDto"
                            [ngClass]="{ 'resaltado': (selectedRowId === row.idRateModel || selectAll)  }">
                            <td>
                                <input [ariaLabel]="row.idRateModel" type="radio" name="checkbox1" id="checkbox1"
                                    [checked]="selectedRowId === row.idRateModel" (click)="toggleRow(row)" />
                            </td>
                            <td>{{ row.codeRateModel}}</td>
                            <td>{{
                                row.rateModelTraductionDto?.[0]?.shortDescription || 'N/A'
                                }}</td>
                            <td>{{ getServiceDescription(row.serviceDto) }}</td>
                            <td>{{ row.active === 'S' ? ('model.active' | translate) : ('model.inactive' | translate) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
            <!-- Controles de paginación -->
            <div class="mt-2" *ngIf="this.modelResponse.pageDto">
                <app-paginator [isStart]="this.modelResponse.pageDto.start" [isEnd]="this.modelResponse.pageDto.end"
                    [isControlPageSize]="true" [currentPage]="this.modelResponse.pageDto.currentPage"
                    [totalPages]="this.modelResponse.pageDto.pages" [numberRecord]="this.modelResponse.pageDto.records"
                    [sizePage]="this.modelResponse.pageDto.pageSize"
                    [control]="'rateModelCatalog'">
                </app-paginator>
            </div>
            }
        </div>

        <div *ngIf="selectedRowId != null || openCreate">
            <div class="separator mt-5"></div>
            <form [formGroup]="formComponent" (ngSubmit)="onSubmit()">
                <div class="mt-5">
                    <div class="row">
                        <h2 class="textformat mb-4">{{'model.taxModel' | translate}}</h2>
                    </div>
                    <div class="row justify-content-between">
                        <div class=" col-4 mb-3">
                            <label for="codeRateModel">{{ 'model.code' | translate}}<span>
                                    *</span></label>
                            <input type="text" name="codeRateModel" id="codeRateModel" class="form-control"
                                placeholder="Código" formControlName="codeRateModel" />
                        </div>
                        <div class=" col-4 mb-3">
                            <label for="active">{{ 'model.status' | translate}}<span>
                                    *</span></label>
                            <select class="form-select" name="active" id="active" formControlName="active">
                                <option value="S">{{ 'model.active' | translate }}</option>
                                <option value="N">{{ 'model.inactive' | translate }}</option>
                            </select>
                        </div>
                        <div class=" col-4 mb-3">
                            <label for="serviceTypeId">{{'model.serviceType' | translate}}<span>
                                    *</span></label>
                            <select class="form-select" id="serviceTypeId" name="serviceTypeId"
                                formControlName="serviceTypeId">
                                <option *ngFor="let service of listServices" [value]="service.idService">
                                    {{
                                    service.serviceTraductionDto[0].shortDescription
                                    ||
                                    'N/A' }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row justify-content-between">
                        <div class=" col-4 mb-3">
                            <label for="shortCastellano">{{'model.nameCast' | translate}}<span>
                                    *</span></label>
                            <input type="text" name="shortCastellano" id="shortCastellano" class="form-control"
                                placeholder="Nombre" formControlName="shortCastellano" />
                        </div>
                        <div class=" col-4 mb-3">
                            <label for="shortCatala">{{'model.nameCat' | translate}}<span>
                                    *</span></label>
                            <input type="text" class="form-control" name="shortCatala" id="shortCatala"
                                placeholder="Nom" formControlName="shortCatala" />
                        </div>
                        <div class=" col-4 mb-3">
                            <label for="shortEnglish">{{'model.nameEng' | translate}}<span>
                                    *</span></label>
                            <input type="text" class="form-control" name="shortEnglish" id="shortEnglish"
                                placeholder="Name" formControlName="shortEnglish" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <label for="longCastellano">{{'model.descriptionCast' | translate}}<span>
                                    *</span></label>
                            <input type="text" name="longCastellano" id="longCastellano" class="form-control"
                                placeholder="Descripción" formControlName="longCastellano" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <label for="longCatala">{{'model.descriptionCat' | translate}}<span>
                                    *</span></label>
                            <input type="text" id="longCatala" name="longCatala" class="form-control"
                                placeholder="Descripció" formControlName="longCatala" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <label for="longEnglish">{{'model.descriptionEng' | translate}}<span>
                                    *</span></label>
                            <input type="text" name="longEnglish" id="longEnglish" class="form-control"
                                placeholder="Description" formControlName="longEnglish" />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 d-flex justify-content-between">
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" id="academicFees" name="academicFees"
                                    formControlName="academicFees" />
                                <label class="form-check-label" for="academicFees">{{'model.academicFees' |
                                    translate}}</label>
                            </div>
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" id="learningResourcesRates"
                                    name="learningResourcesRates" formControlName="learningResourcesRates" />
                                <label class="form-check-label"
                                    for="learningResourcesRates">{{'model.learningResourceFees' |
                                    translate}}</label>
                            </div>
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" id="shippingFees" name="shippingFees"
                                    formControlName="shippingRates" />
                                <label class="form-check-label" for="shippingFees">{{'model.shippingFees' |
                                    translate}}</label>
                            </div>
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" id="administrativeFees"
                                    name="administrativeFees" formControlName="administrativeFees" />
                                <label class="form-check-label" for="administrativeFees">{{'model.administrativeFees' |
                                    translate}}</label>
                            </div>
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" id="surcharges" name="surcharges"
                                    formControlName="surcharges" />
                                <label class="form-check-label" for="surcharges">{{'model.surcharges' |
                                    translate}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="col-12 mt-4">
                            <button type="button" class="btn cancelbutton me-2" (click)="onCancel()">Cancelar</button>
                            <button type="submit" class="btn custombutton">{{!selectedRowId
                                ? ('buttons.save' | translate) : ('buttons.modify' | translate)}}</button>
                        </div>
                    </div>

                </div>
            </form>
        </div>
        <app-alert-component [isDanger]="isError" [isOk]="isCreate" [message]="errorMessage"
            (close)="this.isCreate = this.isError = false"></app-alert-component>
        @if(selectedRowId){
        <div class="row">
            <div class="col-8">
                <h2 class="textformat mt-2">{{'navbar.discounts' | translate}}</h2>
            </div>
            <div class="text-end col mt-2">
                <button type="button" class="btn custombutton ms-2" (click)="createDiscount()">{{'discount.create' |
                    translate}}</button>
            </div>
        </div>
        }

        @if(discountRateModelResponse.discountRateModelCatalogDto &&
        discountRateModelResponse.discountRateModelCatalogDto.length>0){
        <fieldset>
            <table class="table mt-2">
                <thead>
                    <tr>
                        <th scope="col" aria-label="check">
                            <span class="visually-hidden">{{'seleccionar' | translate}}</span>
                        </th>
                        <th>{{ 'discount.codeDiscount' | translate }}</th>
                        <th>{{ 'tariffRole.descripcion' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of this.discountRateModelResponse.discountRateModelCatalogDto"
                        [ngClass]="{ 'resaltado': (selectedRowDiscountId === row.discountRateModelCatalogPkDto?.generalDiscountCatalogId)  }">
                        <td>
                            <input [ariaLabel]="row.discountRateModelCatalogPkDto?.generalDiscountCatalogId"
                                type="radio" name="generalDiscountCatalogId"
                                [checked]="selectedRowDiscountId === row.discountRateModelCatalogPkDto?.generalDiscountCatalogId"
                                (click)="toggleRowDiscount(row)" />
                        </td>
                        <td>{{ row.generalDiscountCatalogDto?.discountCode }}</td>
                        <td>{{ getDiscountDescription(row.generalDiscountCatalogDto?.idGeneralDiscountCatalog) }}</td>
                    </tr>
                </tbody>
            </table>
        </fieldset>
        <!-- Controles de paginación -->
        <div class="mt-2" *ngIf="this.discountRateModelResponse.pageDto">
            <app-paginator [isStart]="this.discountRateModelResponse.pageDto.start"
                [isEnd]="this.discountRateModelResponse.pageDto.end"
                [currentPage]="this.discountRateModelResponse.pageDto.currentPage"
                [totalPages]="this.discountRateModelResponse.pageDto.pages"
                [numberRecord]="this.discountRateModelResponse.pageDto.records"
                [sizePage]="this.discountRateModelResponse.pageDto.pageSize"
                [control]="'discountRateModelCatalog'">
            </app-paginator>
        </div>

        }

        @if (selectedRowDiscountId || isCreateDiscount) {
        <div class="separator mt-5"></div>
        <div class="row">
            @if (selectedRowDiscountId) {
            <h2 class="textformat mt-2 mb-4">{{'discount.editat' | translate}}</h2>
            }@else{
            <h2 class="textformat mt-2 mb-4">{{'discount.create' | translate}}</h2>
            }
        </div>
        <form [formGroup]="formDiscount">
            <div class="row">
                <div class="mb-3 col-6 ">
                    <label for="generalDiscountCatalogId" class="form-label">
                        {{'academicTaxes.discount' | translate}}<span>*</span>
                    </label>
                    @if (!selectedRowDiscountId) {
                  <select id="generalDiscountCatalogId" class="form-select"
                        formControlName="generalDiscountCatalogId">
                        @for (discount of listGeneralDiscountCatalogDto; track discount.idGeneralDiscountCatalog) {
                        @if (isDiscountValid(discount.discountCode)) {
                        <option [value]="discount.idGeneralDiscountCatalog">
                            {{discount.discountCode}} -
                            <span *ngIf="discount.generalDiscountCatalogTraductionDto">
                                {{discount.generalDiscountCatalogTraductionDto[0].discountDescription}}
                            </span>
                        </option>
                        }
                        }
                    </select>
                    }@else {
                        <input type="text" class="form-control" id="generalDiscountCatalogId" name="generalDiscountCatalogId"
                        [value]="getDiscountDescription(formDiscount.get('generalDiscountCatalogId')?.value)" disabled />
                    }
  
                </div>
                <div class="col-6"></div>
                <div class="form-check mb-3 col-6">
                    <input class="form-check-input" type="checkbox" id="studentIndicator" name="studentIndicator"
                        formControlName="studentIndicator" />
                    <label class="form-check-label" for="studentIndicator">{{'model.studentIndicator' |
                        translate}}</label>
                </div>
                <div class="form-check mb-3 col-6">
                    <input class="form-check-input" type="checkbox" id="cumulativeIndicator" name="cumulativeIndicator"
                        formControlName="cumulativeIndicator" />
                    <label class="form-check-label" for="cumulativeIndicator">{{'model.cumulativeIndicator' |
                        translate}}</label>
                </div>
                <div class="form-check mb-3 col-6">
                    <input class="form-check-input" type="checkbox" id="managerIndicator" name="managerIndicator"
                        formControlName="managerIndicator" />
                    <label class="form-check-label" for="managerIndicator">{{'model.managerIndicator' |
                        translate}}</label>
                </div>
                <div class="form-check mb-3 col-6">
                    <input class="form-check-input" type="checkbox" id="usesControlType" name="usesControlType"
                        formControlName="usesControlType" />
                    <label class="form-check-label" for="usesControlType">{{'model.usesControlType' |
                        translate}}</label>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12 mt-4">
                    <button type="button" class="btn cancelbutton me-2"
                        (click)="isCreateDiscount = false ; selectedRowDiscountId=null; formDiscount.reset();discountModelRateControlTypeResponse.discountModelRateControlTypeDto = []">Cancelar</button>
                    <button type="submit" class="btn custombutton" (click)="saveDiscount()">{{!selectedRowDiscountId
                        ? ('buttons.save' | translate) : ('buttons.modify' | translate)}}</button>
                </div>
            </div>

        </form>
        }
        <app-alert-component [isDanger]="isErrorDiscount" [isOk]="isCreatedDiscount" [message]="errorMessage"
            (close)="this.isCreatedDiscount = this.isErrorDiscount = false"></app-alert-component>
        @if (this.formDiscount.get('usesControlType')?.value ||
        discountModelRateControlTypeResponse.discountModelRateControlTypeDto &&
        discountModelRateControlTypeResponse.discountModelRateControlTypeDto.length>0) {
        <div class="row">
            <div class="col-8">
                <h2 class="textformat mt-2">{{'sidebar.discountControl' | translate}}</h2>
            </div>
            <div class="text-end col mt-2">
                <button type="button" class="btn custombutton ms-2" (click)="createDiscountType()">{{'discount.create' |
                    translate}}</button>
            </div>
        </div>
        <fieldset>
            <table class="table mt-2" *ngIf="discountModelRateControlTypeResponse.discountModelRateControlTypeDto &&
        discountModelRateControlTypeResponse.discountModelRateControlTypeDto.length>0">
                <thead>
                    <tr>
                        <th scope="col" aria-label="check">
                            <span class="visually-hidden">{{'seleccionar' | translate}}</span>
                        </th>
                        <th>{{ 'sidebar.controlTypes' | translate }}</th>
                        <th>{{ 'discount.alphanumeric' | translate }}</th>
                        <th>{{ 'discount.numericValue' | translate }}</th>
                        <th>{{ 'discount.decimalValue' | translate }}</th>
                        <th>{{ 'typesVat.date' | translate }}</th>
                        <th>{{ 'typesVat.endDate' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of this.discountModelRateControlTypeResponse.discountModelRateControlTypeDto"
                        [ngClass]="{ 'resaltado': (selectedRowDiscountTypeId === row.idDiscountValidationRateModelWithControl)  }">
                        <td>
                            <input [ariaLabel]="row.idDiscountValidationRateModelWithControl"
                                type="radio" name="check2"
                                [checked]="selectedRowDiscountTypeId === row.idDiscountValidationRateModelWithControl"
                                (click)="toggleRowDiscountType(row)" />
                        </td>
                        <td>{{ row.description }}</td>
                        <td>{{ row.alphanumericValue || '-' }}</td>
                        <td>{{ row.numericValue || '-' }}</td>
                        <td>{{ row.decimalValue || '-' }}</td>
                        <td>{{ row.valueStartDate | date:'dd/MM/yyyy'
                            }}</td>
                        <td>{{ row.valueEndDate | date:'dd/MM/yyyy'
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </fieldset>
        <!-- Controles de paginación -->
        <div class="mt-2" *ngIf="this.discountModelRateControlTypeResponse.pageDto && discountModelRateControlTypeResponse.discountModelRateControlTypeDto &&
        discountModelRateControlTypeResponse.discountModelRateControlTypeDto.length>0">
            <app-paginator [isStart]="this.discountModelRateControlTypeResponse.pageDto.start"
                [isEnd]="this.discountModelRateControlTypeResponse.pageDto.end"
                [currentPage]="this.discountModelRateControlTypeResponse.pageDto.currentPage"
                [totalPages]="this.discountModelRateControlTypeResponse.pageDto.pages"
                [numberRecord]="this.discountModelRateControlTypeResponse.pageDto.records"
                [sizePage]="this.discountModelRateControlTypeResponse.pageDto.pageSize"
                [control]="'discountModelRateControlType'">
            </app-paginator>
        </div>

        }
        @if (selectedRowDiscountTypeId || isCreateDiscountType) {
        <div class="separator mt-5"></div>
        <div class="row">
            @if (selectedRowDiscountTypeId) {
            <h2 class="textformat mt-2 mb-4">{{'discount.editat' | translate}}</h2>
            }@else{
            <h2 class="textformat mt-2 mb-4">{{'discount.create' | translate}}</h2>
            }
        </div>
        <form [formGroup]="formDiscountTypes">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="discountControlTypeId">{{'discount.controlValueType' |translate}}<span>
                            *</span></label>
                    <select (change)="changeControlType()" id="discountControlTypeId" name="discountControlTypeId"
                        class="form-select mt-2" aria-label="activity" formControlName="discountControlTypeId">
                        <option *ngFor="let type of this.listDiscountControlType" [value]="type.idDiscountControlType">
                            {{ type.description }}
                        </option>
                    </select>
                </div>
                @if (formDiscountTypes.get('controlType')?.value=='4') {  
                <div class="col-md-6 mb-3">
                    <label class="form-label" for="numericValue">{{ 'discount.numericValue' | translate }}<span>
                            *</span></label>
                    <input type="number" class="form-control color-text" id="numericValue" name="numericValue" required
                        formControlName="numericValue">
                </div>
                }
                @if (formDiscountTypes.get('controlType')?.value=='3') {

                <div class="col-md-6 mb-3">
                    <label class="form-label" for="dateStart">{{ 'typesVat.date' | translate }}<span>
                            *</span></label>
                    <input type="date" class="form-control color-text" id="dateStart" name="dateStart" required
                        formControlName="dateStart">
                </div>
                <div class="col-md-6 mb-3">
                    <label class="form-label" for="dateEnd">{{ 'typesVat.endDate' | translate }}<span>
                            *</span></label>
                    <input type="date" class="form-control color-text" id="dateEnd" name="dateEnd" required
                        formControlName="dateEnd">
                </div>
                }
            </div>
            <div class="row d-flex">
                <div class="col-12 mt-4">
                    <button type="button" class="btn cancelbutton me-2"
                        (click)="isCreateDiscountType = false ; selectedRowDiscountTypeId=null; formDiscountTypes.reset()">Cancelar</button>
                    <button type="submit" class="btn custombutton" *ngIf="!selectedRowDiscountTypeId"
                        [disabled]="formDiscountTypes.invalid" (click)="saveDiscountType()">{{!selectedRowDiscountTypeId
                        ? ('buttons.save' | translate) : ('buttons.modify' | translate)}}</button>
                    <button *ngIf="selectedRowDiscountTypeId" type="button" class="btn btn-danger ms-2"
                        (click)="deleteDiscountType()">{{ ('buttons.delete' | translate)}}</button>
                </div>
            </div>

        </form>
        }
        <app-alert-component [isDanger]="isErrorDiscountType" [isOk]="isCreatedDiscountType" [message]="errorMessage"
            (close)="this.isCreatedDiscountType = this.isErrorDiscountType = false"></app-alert-component>
    </main>
</div>